/**
 * Product page enhancements
 * - Description structure: "Suggested use" callout card, "Good to know" collapsible row,
 *   arrow bullets for "What to expect", tagline + badge line (see enhanceDescription)
 * - Turns the "Ingredients:" description paragraph into a collapsible row (links preserved)
 * - Buy box order (arrangeBuyBox): title, price, price note, short description (tagline + intro,
 *   3 lines + a "What to expect & how to use" toggle that opens the rest of the intro plus What
 *   to expect and the Suggested use card), badges as checks, "See lab results" (opens the lab
 *   popup, snippets/ss-lab-popup.liquid), purchase options, Add to Cart, then the rest of the
 *   description (Questions, Good to know, Ingredients).
 *   The description is rendered below the product grid by main-product.liquid; this moves it
 *   into the buy box so it also shows on desktop.
 * - Purchase options in the handover style (planSelector), driving Loop's real options
 * - Adds swipe dots under the mobile product gallery
 * - Mobile sticky add-to-cart: shows once the main Add to Cart is scrolled past;
 *   clicking it clicks the real button (keeps the selected subscription/one-time option)
 */
(function () {
  // Description structure (authored in Shopify admin as plain <h3> headings):
  //   <p><em>tagline</em></p>, <p><strong>A · B · C</strong></p>,
  //   <h3>What to expect</h3><ul>…</ul>, <h3>Suggested use</h3><p>…</p>, <h3>Good to know</h3><ul>…</ul>
  // Descriptions without these headings are left untouched.
  function enhanceDescription() {
    document.querySelectorAll('.product__description').forEach(function (desc) {
      if (desc.dataset.pcEnhanced) return;
      desc.dataset.pcEnhanced = '1';

      var first = desc.firstElementChild;
      if (first && first.tagName === 'P' && first.children.length === 1 &&
          first.firstElementChild.tagName === 'EM' &&
          first.textContent.trim() === first.firstElementChild.textContent.trim()) {
        first.classList.add('pc-tagline');
      }
      desc.querySelectorAll(':scope > p').forEach(function (p) {
        var s = p.querySelector(':scope > strong');
        if (s && p.children.length === 1 && p.textContent.trim() === s.textContent.trim() &&
            s.textContent.indexOf('\u00b7') > -1) {
          p.classList.add('pc-badges');
          p.innerHTML = s.textContent.split('\u00b7').map(function (t) {
            return '<span>' + t.trim().replace(/[<>&]/g, '') + '</span>';
          }).join('');
        }
      });

      var headings = Array.prototype.filter.call(desc.children, function (el) {
        return /^H[2-4]$/.test(el.tagName);
      });
      headings.forEach(function (h) {
        var title = (h.textContent || '').trim();
        var key = title.toLowerCase();
        var body = [];
        var n = h.nextElementSibling;
        while (n && !/^H[2-4]$/.test(n.tagName) && !/^ingredients\s*:/i.test((n.textContent || '').trim())) {
          body.push(n);
          n = n.nextElementSibling;
        }

        if (/^what to expect/.test(key)) {
          h.classList.add('pc-subhead');
          body.forEach(function (el) { if (el.tagName === 'UL') el.classList.add('pc-expect'); });
        } else if (/^suggested use/.test(key) && body.length) {
          var card = document.createElement('div');
          card.className = 'pc-use';
          var label = document.createElement('p');
          label.className = 'pc-use__label';
          label.textContent = title;
          card.appendChild(label);
          var steps = ((body[0].textContent || '').trim().match(/[^.!?]+[.!?]+|[^.!?]+$/g) || []).map(function (t) { return t.trim(); }).filter(Boolean);
          var ol = document.createElement('ol');
          ol.className = 'pc-use__steps';
          steps.forEach(function (t) {
            var li = document.createElement('li');
            li.textContent = t;
            ol.appendChild(li);
          });
          card.appendChild(ol);
          body.slice(1).forEach(function (el) {
            el.classList.add('pc-use__note');
            card.appendChild(el);
          });
          body[0].remove();
          h.replaceWith(card);
        } else if (/^good to know/.test(key) && body.length) {
          var details = document.createElement('details');
          details.className = 'pc-ingredients pc-goodtoknow';
          var summary = document.createElement('summary');
          summary.textContent = title;
          details.appendChild(summary);
          body.forEach(function (el) { details.appendChild(el); });
          h.replaceWith(details);
        }
      });
    });
  }

  function collapseIngredients() {
    document.querySelectorAll('.product__description').forEach(function (desc) {
      if (desc.dataset.pcIngredients) return;
      desc.dataset.pcIngredients = '1';
      desc.querySelectorAll('p').forEach(function (p) {
        var text = (p.textContent || '').trim();
        if (!/^ingredients\s*:/i.test(text)) return;
        if (!text.replace(/^ingredients\s*:\s*/i, '')) return;
        var details = document.createElement('details');
        details.className = 'pc-ingredients';
        var summary = document.createElement('summary');
        summary.textContent = 'Ingredients';
        // Move the paragraph's nodes (keeps links), then strip the leading "Ingredients:" label
        var content = document.createElement('p');
        while (p.firstChild) content.appendChild(p.firstChild);
        while (content.firstChild) {
          var node = content.firstChild;
          if (node.nodeType === 3) {
            node.textContent = node.textContent.replace(/^\s*ingredients\s*:\s*/i, '');
            if (!node.textContent.trim()) { content.removeChild(node); continue; }
            break;
          }
          if (node.nodeName === 'BR' || node.nodeName === 'META') { content.removeChild(node); continue; }
          break;
        }
        details.appendChild(summary);
        details.appendChild(content);
        p.replaceWith(details);
      });
    });
  }

  // Puts the page in reading order inside the buy box (see header comment).
  function arrangeBuyBox() {
    var info = document.querySelector('.product__info-container[id^="ProductInfo-"]');
    if (!info || info.dataset.pcArranged) return;
    var holder = document.querySelector('.c-product-description');
    var desc = holder && holder.querySelector('.product__description');
    var buy = info.querySelector('.buttons-card-buy');
    if (!desc || !buy) return;
    info.dataset.pcArranged = '1';

    var intro = document.createElement('div');
    intro.className = 'pc-intro';
    var tagline = desc.querySelector(':scope > .pc-tagline');
    var badges = desc.querySelector(':scope > .pc-badges');
    // Short description under the price (Hero 1 handover): tagline + intro paragraph, clamped
    // to 3 lines; then the badges as check items and the lab results link.
    var lead = document.createElement('div');
    lead.className = 'pc-lead';
    if (tagline) lead.appendChild(tagline);
    var firstP = Array.prototype.find.call(desc.children, function (el) {
      return el.tagName === 'P' && !el.className && (el.textContent || '').trim() &&
        !/^ingredients\s*:/i.test((el.textContent || '').trim());
    });
    var firstHead = desc.querySelector(':scope > .pc-subhead, :scope > .pc-use, :scope > details');
    if (firstP && (!firstHead || (firstP.compareDocumentPosition(firstHead) & Node.DOCUMENT_POSITION_FOLLOWING))) {
      firstP.classList.add('pc-lead__text');
      lead.appendChild(firstP);
    }
    if (lead.children.length) {
      intro.appendChild(lead);
      // What to expect + the Suggested use card live behind the toggle (Oct 9), so the toggle
      // reveals real content instead of a few more words of the intro. Styles: product-more.css.
      var panel = document.createElement('div');
      panel.className = 'pc-more';
      panel.id = 'pc-more-' + (info.id || 'main');
      var expectHead = desc.querySelector(':scope > .pc-subhead');
      if (expectHead) {
        var expectList = expectHead.nextElementSibling;
        panel.appendChild(expectHead);
        if (expectList && expectList.tagName === 'UL') panel.appendChild(expectList);
      }
      var useCard = desc.querySelector(':scope > .pc-use');
      if (useCard) panel.appendChild(useCard);
      var hasPanel = panel.children.length > 0;

      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'pc-lead__more';
      var closedLabel = hasPanel ? 'What to expect & how to use' : 'Read more';
      var openLabel = hasPanel ? 'Show less' : 'Read less';
      more.textContent = closedLabel;
      more.setAttribute('aria-expanded', 'false');
      if (hasPanel) more.setAttribute('aria-controls', panel.id);
      more.addEventListener('click', function () {
        var open = lead.classList.toggle('is-open');
        panel.classList.toggle('is-open', open);
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? openLabel : closedLabel;
      });
      intro.appendChild(more);
      if (hasPanel) {
        intro.appendChild(panel);
      } else {
        requestAnimationFrame(function () {
          if (lead.scrollHeight <= lead.clientHeight + 2) more.hidden = true;
        });
      }
    }
    if (badges) intro.appendChild(badges);
    // Opens the lab results popup (assets/ss-lab-popup.js); plain link if the popup isn't there
    var lab = document.createElement('a');
    lab.className = 'pc-lab-link';
    lab.href = '/pages/lab-results';
    lab.setAttribute('data-lab-popup', '');
    lab.textContent = 'See lab results';
    if (!document.getElementById('ss-lab-popup')) lab.removeAttribute('data-lab-popup');
    intro.appendChild(lab);
    if (intro.children.length) {
      var anchor = info.querySelector('.pc-price-note') || info.querySelector('[id^="price-"]');
      if (anchor) anchor.insertAdjacentElement('afterend', intro);
    }

    desc.classList.add('pc-desc-moved');
    buy.insertAdjacentElement('afterend', desc);
    holder.style.display = 'none';
  }

  // Purchase options in the handover style (Hero 1): our own two-row selector (switch for
  // Subscribe and Save, dot for One Time Purchase) drives Loop's real options, which stay in
  // the page (visually hidden) so cart/checkout behaviour is unchanged. If Loop's options
  // can't be found, Loop's own widget is left as is.
  function planSelector() {
    var tries = 0;
    (function attempt() {
      var loop = document.querySelector('.product__info-container .loop-widget-container') ||
        document.querySelector('.loop-widget-container');
      var opts = loop ? Array.prototype.slice.call(loop.querySelectorAll('.loop-widget-purchase-option')) : [];
      if (opts.length < 2) {
        if (++tries < 24) setTimeout(attempt, 250);
        return;
      }
      if (loop.dataset.pcPlan) return;
      loop.dataset.pcPlan = '1';

      var read = function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var prices = t.match(/\$\s?[\d,]+(?:\.\d{2})?/g) || [];
        var input = el.querySelector('input[type="radio"]');
        return {
          sub: /subscri/i.test(t),
          price: prices.length ? prices[prices.length - 1].replace(/\s/g, '') : '',
          pct: (t.match(/(\d+)\s*%/) || [])[1],
          selected: !!((input && input.checked) || /selected/.test(el.className)),
          input: input
        };
      };
      var loopText = (loop.textContent || '').replace(/\s+/g, ' ');
      var note = /month/i.test(loopText) ? 'Monthly delivery \u00b7 Modify or cancel anytime' : 'Modify or cancel anytime';

      var ui = document.createElement('div');
      ui.className = 'pc-plan';
      ui.setAttribute('role', 'radiogroup');
      ui.setAttribute('aria-label', 'Purchase options');
      var rows = opts.map(function (el) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.className = 'pc-plan__opt';
        b.addEventListener('click', function () {
          var d = read(el);
          (d.input || el).click();
          setTimeout(sync, 60);
        });
        return { el: el, b: b, sub: read(el).sub };
      });
      rows.sort(function (a, b) { return (b.sub ? 1 : 0) - (a.sub ? 1 : 0); });
      rows.forEach(function (r) { ui.appendChild(r.b); });

      function sync() {
        rows.forEach(function (r) {
          var d = read(r.el);
          r.b.classList.toggle('pc-plan__opt--sub', d.sub);
          r.b.classList.toggle('is-selected', d.selected);
          r.b.setAttribute('aria-checked', d.selected ? 'true' : 'false');
          var label = d.sub ? 'Subscribe and Save' + (d.pct ? ' ' + d.pct + '%' : '') : 'One Time Purchase';
          r.b.innerHTML = '<span class="pc-plan__head"><span class="pc-plan__ctl" aria-hidden="true"></span>' +
            '<span class="pc-plan__label"></span><span class="pc-plan__price"></span></span>' +
            (d.sub ? '<span class="pc-plan__note"></span>' : '');
          r.b.querySelector('.pc-plan__label').textContent = label;
          r.b.querySelector('.pc-plan__price').textContent = d.price;
          if (d.sub) r.b.querySelector('.pc-plan__note').textContent = note;
        });
      }

      loop.parentNode.insertBefore(ui, loop);
      loop.classList.add('pc-loop-hidden');
      sync();
      new MutationObserver(sync).observe(loop, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked']
      });
    })();
  }

  function galleryDots() {
    document.querySelectorAll('ul[id^="Slider-Gallery-"]').forEach(function (list) {
      if (list.dataset.pcDots) return;
      var items = Array.prototype.filter.call(list.children, function (li) {
        return li.classList.contains('product__media-item');
      });
      if (items.length < 2) return;
      list.dataset.pcDots = '1';
      list.classList.add('pc-gallery');

      var dots = document.createElement('div');
      dots.className = 'pc-dots';
      dots.setAttribute('aria-hidden', 'true');
      items.forEach(function () {
        dots.appendChild(document.createElement('span'));
      });
      var host = list.closest('slider-component') || list;
      host.insertAdjacentElement('afterend', dots);

      var update = function () {
        var visible = items.filter(function (li) {
          return !li.classList.contains('hidden') && li.offsetWidth > 0;
        });
        if (visible.length < 2) {
          dots.style.display = 'none';
          return;
        }
        dots.style.display = '';
        var step = visible[1].offsetLeft - visible[0].offsetLeft || visible[0].offsetWidth || 1;
        var active = Math.min(visible.length - 1, Math.max(0, Math.round(list.scrollLeft / step)));
        Array.prototype.forEach.call(dots.children, function (dot, i) {
          dot.style.display = i < visible.length ? '' : 'none';
          dot.classList.toggle('is-active', i === active);
        });
      };

      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function stickyAddToCart() {
    var bar = document.querySelector('[data-pc-sticky]');
    if (!bar || bar.dataset.pcReady) return;
    // The product template renders more than one Add to Cart (desktop/mobile layouts);
    // always work with whichever one is actually visible.
    var candidates = Array.prototype.slice.call(
      document.querySelectorAll('button.product-form__submit[name="add"]')
    );
    if (!candidates.length) return;
    bar.dataset.pcReady = '1';

    var btn = bar.querySelector('[data-pc-sticky-btn]');
    var mobile = window.matchMedia('(max-width: 749px)');

    var visibleMain = function () {
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].getClientRects().length > 0) return candidates[i];
      }
      return null;
    };

    // Mirror the main button's label (Loop changes it to "Add subscription to cart"),
    // shortened to fit the bar.
    var labelFor = function (main) {
      var t = ((main.querySelector('span') || main).textContent || '').replace(/\s+/g, ' ').trim();
      if (/subscri/i.test(t)) return 'Subscribe';
      return t || 'Add to cart';
    };

    // Price line follows the selected purchase option (Loop): the subscription price when
    // Subscribe is selected, otherwise the regular price + per-gummy note rendered in Liquid.
    var priceEl = bar.querySelector('.pc-sticky__price');
    var basePrice = priceEl ? priceEl.textContent : '';
    var selectedPrice = function () {
      var sel = document.querySelector('.loop-widget-purchase-option-selected');
      if (!sel) return null;
      var m = (sel.textContent || '').match(/\$\s?[\d,]+(?:\.\d{2})?/g);
      return m ? m[m.length - 1].replace(/\s/g, '') : null;
    };

    var syncState = function () {
      var main = visibleMain();
      if (!main) return;
      var disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      btn.disabled = disabled;
      var label = labelFor(main);
      btn.textContent = disabled ? 'Sold out' : label;
      if (priceEl) {
        var sp = label === 'Subscribe' ? selectedPrice() : null;
        priceEl.textContent = sp ? sp + ' subscription' : basePrice;
      }
      // Match the real Add to Cart's look (colour, type) so the bar mirrors it
      var cs = window.getComputedStyle(main);
      btn.style.backgroundColor = cs.backgroundColor;
      btn.style.color = cs.color;
      btn.style.fontFamily = cs.fontFamily;
      btn.style.fontWeight = cs.fontWeight;
      btn.style.letterSpacing = cs.letterSpacing;
      btn.style.textTransform = cs.textTransform;
    };

    candidates.forEach(function (c) {
      new MutationObserver(syncState).observe(c, {
        attributes: true, attributeFilter: ['disabled', 'aria-disabled'],
        childList: true, characterData: true, subtree: true
      });
    });

    btn.addEventListener('click', function () {
      var main = visibleMain();
      if (main && !btn.disabled) main.click();
    });

    // Shopify's preview banner (staging/draft links) is fixed to the bottom of the screen
    // and would cover the bar; sit above it when it's present.
    var previewOffset = function () {
      var el = document.getElementById('PBarNextFrameWrapper') ||
        document.getElementById('preview-bar-iframe') ||
        document.getElementById('PBarNextFrame');
      if (!el) return 0;
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.top < window.innerHeight ? Math.max(0, window.innerHeight - r.top) : 0;
    };

    var ticking = false;
    var check = function () {
      ticking = false;
      syncState();
      bar.style.bottom = previewOffset() + 'px';
      var main = visibleMain();
      var show = !!(main && mobile.matches && main.getBoundingClientRect().bottom < 0);
      bar.hidden = !mobile.matches;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('pc-sticky-on', show);
    };

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }, { passive: true });
    window.addEventListener('resize', check);
    syncState();
    check();
  }

  function init() {
    enhanceDescription();
    collapseIngredients();
    arrangeBuyBox();
    planSelector();
    galleryDots();
    stickyAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
